import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/mfa/verify", "/auth/register"];
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !NO_RETRY.some((p) => cfg.url?.includes(p))) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const mediaUrl = (p) => (p ? `${BACKEND}${p}` : null);

export function useCatalog() {
  return useQuery({ queryKey: ["catalog"], queryFn: () => api.get("/catalog").then((r) => r.data), staleTime: 600000 });
}

export const homeFor = (user) => {
  const r = user?.primary_role || user?.roles?.[0];
  return { consumer: "/account", worker: "/worker", provider: "/provider", admin: "/admin" }[r] || "/";
};

export const SEARCH_KEY = "cz_search_session";
export const fmtDate = (s) => (s ? new Date(s.length === 10 ? s + "T12:00:00" : s).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "—");
export const label = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
